import { IRoute } from "src/pages/Router/routes";

import AdminMain from "./Admin";
import CustomerMain from "./Customer";

export const Main: IRoute[] = [ ...AdminMain, ...CustomerMain ];

export default Main;
